//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { parseCategory } from '~/utils/api'
import { theme } from '~/tailwind.config'
import { LANGUAGE_FLAG_IMGS } from '~/utils/runtimeConstants'
import { COUNTRY_FI, COUNTRY_GB, COUNTRY_SE, LANGUAGE_EN, LANGUAGE_FI, LANGUAGE_SV } from '~/utils/constants'

export default {
  props: {
    showSearch: {
      type: Boolean,
      default: true,
    },
    searchPlaceholder: {
      type: String,
      required: true,
    },
    searchExamples: {
      type: Array,
      default: null,
    },
    searchExamplesHeading: {
      type: String,
      default: '',
    },
    defaultCategorySlug: {
      type: String,
      default: null,
    },
    showCategories: {
      type: Boolean,
      default: true,
    },
    categoryChooserLabel: {
      type: String,
      default: '',
    },
    templatesClass: {
      type: String,
      default: '',
    },
  },
  data () {
    return {
      categories: [],
      templates: [],
      nRemainingTemplates: 0,
      activeCategory: null,
      loadingTemplates: false,
      loadingRemainingTemplates: false,
      pagination: null,
      languageFilter: this.$route.query.language || 'all',
      isAskForTemplateModalOpen: false,
    }
  },
  fetchKey (getCounter) {
    return `templates-categories:${this.$route.params.categoryId || 'index'}:${getCounter('templates-categories')}`
  },
  async fetch () {
    // Fetch all categories
    try {
      const categories = await this.$api.getCategories().then(r => r.data.data.map(parseCategory))

      // Support new simplified category listing
      // where there are only one level of categories
      // This can be cleaned after we have removed extra categories from backend.
      // TODO: Clean after backend returns only one level categories
      const countOfParentCategories = categories.filter(c => !c.parentCategoryId).length
      if (countOfParentCategories > 2) {
        // New category listing
        this.categories = categories
      } else {
        // Old listing, get categories from "company main category"
        const companyCategoryId = categories.find(c => ['dokument-for-foretag', 'yrityssopimukset', 'company-documents'].includes(c.slug))?.id
        this.categories = categories.filter(c => c.parentCategoryId === companyCategoryId)
      }

      if (this.defaultCategorySlug) {
        this.activeCategory = this.categories.find(c => c.slug === this.defaultCategorySlug)
      } else if (this.$route.params.categoryId) {
        this.activeCategory = this.categories.find(c => c.id === this.$route.params.categoryId)
      }

      await this.loadTemplates({ limit: 25 })
    } catch (e) {
      this.categories = []
    }
  },
  computed: {
    availableTemplateLanguages () {
      switch (this.$country.current.countryCode) {
        case COUNTRY_FI:
          return [LANGUAGE_FI, LANGUAGE_SV, LANGUAGE_EN]
        case COUNTRY_SE:
          return [LANGUAGE_SV, LANGUAGE_EN]
        case COUNTRY_GB:
        default:
          return [LANGUAGE_EN]
      }
    },
    languageOptions () {
      return [{
        text: this.$t('templatesCategories.language-select-default'),
        value: 'all'
      }].concat(this.availableTemplateLanguages.map(l => ({ text: this.$intl.language.displayName(l), value: l })))
    },
    languageFilterEnabled () {
      return this.availableTemplateLanguages.length > 1
    }
  },
  watch: {
    languageFilter (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.onLanguageChange(newVal)
      }
    }
  },
  methods: {
    flag (l) {
      return LANGUAGE_FLAG_IMGS[l]
    },
    categorySelectChanged (e) {
      const val = e.target.value
      this.selectCategory(val ? this.categories.find(c => c.id === val) : null)
    },
    onLanguageChange (l) {
      this.loadTemplates()
      this.scrollToCategories()
      if (l === 'all') {
        this.setQuery('')
      } else {
        this.setQuery(`?language=${l}`)
      }
    },
    selectCategory (nullableCategory) {
      this.activeCategory = nullableCategory
      this.loadTemplates()
      this.scrollToCategories()
      const path = nullableCategory ? this.$url.templateCategory(nullableCategory.id, nullableCategory.slug) : this.$url.allTemplates()
      this.setUrl(path + window.location.search)
    },
    setQuery (q) {
      this.setUrl(window.location.pathname + q)
    },
    setUrl (url) {
      window.history.pushState({}, '', url)
      this.$gtm.push({
        event: 'nuxtRoute',
        pageType: 'PageView',
        pageUrl: window.location.href
      })
    },
    async loadTemplates (options = {}) {
      const { limit = 25, showLoader = true } = options
      if (showLoader) {
        this.loadingTemplates = true
      }

      const params = this.languageFilter === 'all' ? {} : { language: this.languageFilter }

      let response
      if (this.activeCategory) {
        response = await this.$api.getTemplatesByCategory(this.activeCategory.id, limit, params)
      } else {
        response = await this.$api.getTemplates(limit, params)
      }

      this.templates = response.data.data.map(t => ({
        id: t.id,
        name: t.attributes.name,
        slug: t.attributes.slug,
        language: t.attributes.language,
        unitPrice: t.attributes.unitPrice,
        unitPriceWithTax: t.attributes.unitPriceWithTax
      }))

      if (response.data.meta?.pagination) {
        this.pagination = response.data.meta.pagination
        this.nRemainingTemplates = Math.max(0, this.pagination.total - limit)
      } else {
        this.nRemainingTemplates = 0
        this.pagination = null
      }

      this.loadingTemplates = false
    },
    async loadRemainingTemplates () {
      this.loadingRemainingTemplates = true
      await this.loadTemplates({ limit: this.pagination.total, showLoader: false })
      this.loadingRemainingTemplates = false
    },
    scrollToCategories () {
      const screenLgMin = Number(theme.screens.lg.split('px')[0])
      const headerHeight = window.innerWidth < screenLgMin ? 72 : 104
      window.scrollTo(0, this.$refs.categoriesTop.offsetTop - headerHeight)
    }
  }
}
